export default __webpack_public_path__ + "static/media/Toro.3c46b65c.png";